<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="dmplist" label="DMP包管理" v-if="authList"></TabPane>
            <TabPane name="dmpsplit" label="媒体分包配置" v-if="authSplit"></TabPane>
            <TabPane name="dmppush" label="媒体推送" v-if="currentRoute === 'dmppush'"></TabPane>
            <TabPane name="dmpadd" :label="`${edit ? '修改' : '新建'}DMP包`" v-if="currentRoute === 'dmpadd'"></TabPane>
            <TabPane name="autoupload" label="自动上传账号配置" v-if="currentRoute === 'autoupload'"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'dmpmanagelayout',
  computed: {
    authList() {
      return isArray(this.access) && this.access.includes('M20804')
    },
    authSplit() {
      return isArray(this.access) && this.access.includes('M20805')
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      const hasAllAccess = ['M20804', 'M20805'].every((ret) => this.access.includes(ret))
      this.edit = this.$route.query.t === 'edit'
      this.currentRoute = this.$route.name
      if (hasAllAccess && this.currentRoute === 'dmpmange') this.changeRouter('dmplist')
      else if (this.currentRoute === 'dmpmange') {
        if (this.access.includes('M20804')) this.changeRouter('dmplist')
        else if (this.access.includes('M20805')) this.changeRouter('dmpsplit')
        else this.changeRouter('noauth')
      }
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      edit: false,
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
